import { connect } from 'react-redux';
import { getBackground } from '../redux/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    background: getBackground(state, ownProps.deviation),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=StageBackground.container.js.map